import { call } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { FolderType, GroupFolderId } from './types';
import {
  PapiRequestDaDeviationGroupFolders,
  PapiDaDeviationGroupFolders,
  PapiGallection,
  PapiRequestDaDeviationGroupAdd,
  PapiDaDeviationGroupAdd,
} from '@wix/da-papi-types';

export function* fetchGroupFolders(groupId: number, folderType: FolderType) {
  const params: PapiRequestDaDeviationGroupFolders = {
    groupid: groupId,
    type: folderType,
  };

  const result: PapiDaDeviationGroupFolders | false = yield call(
    requestPuppy,
    {
      method: 'get',
      url: 'group_folders',
      params,
    },
    (): PapiDaDeviationGroupFolders => {
      if (process.env.NODE_ENV !== 'production') {
        const collections: PapiGallection[] =
          // eslint-disable-next-line global-require
          require('@wix/da-sample-data').collections;

        return {
          results: collections,
        };
      }
      return {
        results: [],
      };
    },
    'dadeviation'
  );

  return result;
}

export function* addDeviationToGroupFolder(
  groupFolderId: GroupFolderId,
  deviationId: number
) {
  const data: PapiRequestDaDeviationGroupAdd = {
    groupid: groupFolderId.groupId,
    type: groupFolderId.type,
    folderid: groupFolderId.folderId,
    deviationid: deviationId,
  };
  const result: PapiDaDeviationGroupAdd = yield call(
    requestPuppy,
    {
      method: 'post',
      url: 'group_add',
      data,
    },
    (): PapiDaDeviationGroupAdd => {
      return { success: true };
    },
    'dadeviation'
  ) || { success: false };

  return result;
}
